<app-message-box *ngIf="errors.unexpectedError" unexpectedError></app-message-box>

<app-wait *ngIf="loading" waitText="Please wait while we log you in..."></app-wait>